import produce from "immer";
import actionTypes from "../actionTypes/editor";

const initialState = {};

export default function editor(state = initialState, { payload, type }) {
  const nextState = produce(state, (draft) => {
    switch (type) {
      case actionTypes.UPDATE_EDITOR_VALUE: {
        const { value, problemId } = payload;
        draft[problemId] = value;
        break;
      }
      default:
    }
  });

  return nextState;
}
